import { Config } from "config/config.type"
/** @firescoutMockVar Config.config */
const config:Config = {
  "env": "prod",
  "location": "lusini_sv-se",
  "shopName": "lusini",
  "locale": "sv-se",
  "rootCategoryId": "EMG",
  "availableCreditCards": [
    "MASTERCARD",
    "VISA"
  ],
  "orderMinimumB2C": 500,
  "links": {
    "contact": "/kundservice/kontakta-oss/"
  },
  "i18n": {
    "currency_ISO": "SEK",
    "locale": "sv-SE",
    "country": "SE"
  },
  "languages": {
    "de": "Tyska",
    "en": "Engelska",
    "fr": "Franska",
    "es": "Spanska",
    "it": "Italienska",
    "nl": "Nederländska",
    "pt": "Portugisiska",
    "sv": "Svenska",
    "da": "Danska",
    "nb": "Norska",
    "hr": "Kroatiska"
  },
  "slugifyLocale": "sv",
  "hrefLang": [
    {
      "configFolder": "lusini",
      "locale": "sv-se",
      "hrefLang": "sv"
    }
  ],
  "baseUrl": "https://www.lusini.com",
  "functions": {
    "clientdata": "https://functions.lusini.com/.netlify/functions/clientdata",
    "newsletter": {
      "getOptInStatus": "https://functions.lusini.com/.netlify/functions/newsletter-getOptInStatus",
      "createContactWithOptIn": "https://functions.lusini.com/.netlify/functions/newsletter-createContactWithOptIn",
      "setOptInStatus": "https://functions.lusini.com/.netlify/functions/newsletter-setOptInStatus"
    },
    "creditsave": {
      "address": "https://functions.lusini.com/.netlify/functions/creditsafe-address"
    },
    "shareCart": {
      "POST": "https://functions.lusini.com/.netlify/functions/shareCart-POST",
      "GET": "https://functions.lusini.com/.netlify/functions/shareCart-GET"
    },
    "raffle": {
      "registration": "https://functions.lusini.com/.netlify/functions/POST-raffle-registration"
    }
  },
  "modules": {
    "onetrust": {
      "dataDomainScript": "bda0c016-94be-4fd9-943a-b9c09791a327"
    },
    "buzdev": {
      "errorUrl": "https://buz.lusini.com/webhook/com.lusini.commerce-platform/error/1-0-1"
    },
    "cloudinary": {
      "endpoint": "https://res.cloudinary.com/lusini/",
      "transformations": {
        "freisteller_l": "w_1500,h_1500,q_80,c_pad,f_auto",
        "freisteller_l_2": "w_1500,h_1500,q_80,c_pad,f_auto",
        "milieu_l": "w_1500,h_1500,g_auto,q_80,c_fill,f_auto",
        "milieu_l_2": "w_1500,h_1500,g_auto,q_80,c_fill,f_auto",
        "freisteller_m": "w_500,h_500,q_70,c_pad,f_auto",
        "freisteller_m_2": "w_500,h_500,q_70,c_pad,f_auto",
        "milieu_m": "ws_500,h_500,g_auto,q_70,c_fill,f_auto",
        "milieu_m_2": "ws_500,h_500,g_auto,q_70,c_fill,f_auto",
        "freisteller_s": "w_300,h_300,q_70,c_pad,f_auto",
        "freisteller_s_2": "w_600,h_600,q_70,c_pad,f_auto",
        "milieu_s": "w_300,h_300,g_auto,q_70,c_fill,f_auto",
        "milieu_s_2": "w_600,h_600,g_auto,q_70,c_fill,f_auto",
        "freisteller_xs": "w_50,h_50,q_50,c_pad,fl_lossy,f_auto",
        "freisteller_xs_2": "w_100,h_100,q_50,c_pad,fl_lossy,f_auto",
        "milieu_xs": "w_50,h_50,g_auto,q_50,c_fill,fl_lossy,f_auto",
        "milieu_xs_2": "w_100,h_100,g_auto,q_50,c_fill,fl_lossy,f_auto"
      },
      "fallback_product_picture": "https://res.cloudinary.com/lusini/image/upload/v1643182695/application/products/lusini-online-shop-platzhalter-produktbild-in-kuerze-sv.svg",
      "newsletter_intentlayer_picture": "https://res.cloudinary.com/lusini/image/upload/v1724665736/application/NewsletterPopupAB/discount-reduction-sv-se.svg"
    },
    "shopware": {
      "salutations": [],
      "initialSaluationId": "6d0b33d96b5b400cbabc648c0a4c3f60",
      "accessKey": {
        "b2b": "SWSCRRAMGR3FEVS5ORJNWEB46X",
        "b2c": "SWSCADFNRHV0R1CYREKSQJLAOH"
      },
      "storefrontUrl": {
        "b2b": "https://www.lusini.com/sv-se/b2b",
        "b2c": "https://www.lusini.com/sv-se/b2c"
      },
      "apiUrl": "https://shop-api.lusini.com/store-api"
    },
    "algolia": {
      "apiKey": "bf4bf9193d5f34cd369647376521dbc8",
      "applicationId": "WAVYBEW6OQ"
    },
    "contentful": {
      "space": "aza65graowyr",
      "environment": "master",
      "accessToken": "OExq-bY8Ujs7M06rQEL1drC2kfafk-qmEzA8DZO0CCE",
      "previewToken": "QP7JxRhc0mYWGrX3I8vj9WdBO_eF7n9r0xnmcX11HAw"
    },
    "dyHybrid": {
      "apiKey": "a72829a6281955d5f8febc70eeb0a8de8a9f4841db410f4012d1fb4bf2dc5ffa",
      "campaignID": "9879544"
    },
    "trustShop": {
      "placeholderImg": "https://res.cloudinary.com/lusini/image/upload/c_scale,w_100/v1670412947/application/icons/trygg-e-handel.svg",
      "id": "271d2d78-97d0-4eb0-b4b9-ef5b1c0c561e",
      "url": "https://cert.tryggehandel.net/js/script.js?id=",
      "urlPostfix": ""
    },
    "zenloop": {
      "id": "WXpkbU1HTmlaVGN0T1RObVlTMDBOV1l6TFRnMlpqZ3RORGxsTmprMllqQXpOalUx"
    },
    "hotjar": {
      "id": 3549008,
      "version": 6
    }
  },
  "index": {
    "products": "prod_lusini_sv_SE_products",
    "productsPriceAsc": "prod_lusini_sv_SE_products_priceAsc",
    "productsPriceDesc": "prod_lusini_sv_SE_products_priceDesc",
    "categories": "prod_lusini_sv_SE_categories",
    "series": "prod_lusini_sv_SE_series",
    "productsSuggestion": "prod_lusini_sv_SE_products_query_suggestions",
    "productsLatest": "prod_lusini_sv_SE_products_noveltiesAsc",
    "productReviews": "prod_lusini_product_reviews",
    "serviceReviews": "prod_lusini_service_reviews"
  },
  "deliveryDate": {
    "shippingTooLong": 200
  },
  "colors": {
    "Vit": "white",
    "Svart": "black",
    "Grå": "grey",
    "Silverfärg": "silver",
    "Brun": "brown",
    "Blå": "blue",
    "Flerfärgad": "multicolor",
    "Röd": "red",
    "Beige": "beige",
    "Grön": "green",
    "Transparent": "transparent",
    "Gul": "yellow",
    "Guldfärg": "gold",
    "Orange": "orange",
    "Rosa/Lila": "lilac"
  },
  "features": {
    "leadinfo": true,
    "devMode": false,
    "trustShop": true,
    "zenloop": true,
    "qrCode": false,
    "acceptanceOfTermsRequiredForOrderingB2C": true,
    "acceptanceOfTermsRequiredForOrderingB2B": true,
    "showProductRecommendationInfoTextB2B": true,
    "showProductRecommendationInfoTextB2C": true,
    "b2c": true,
    "notificationBar": true,
    "showNewsletterIntentLayer": true,
    "userLikeWidgetUrl": "https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com/ad3dc80e2f1e028479e97e8763119dbd18e685c6931bcea7bac7dc125f5d1835.js",
    "customizableUrl": "https://www.lusini.com/sv-se/kundservice/service/profilering/",
    "b2cHomePage": true,
    "showCartInfoboxFrom": "2024-12-12T08:00:00",
    "showCartInfoboxTo": "2024-12-21T01:00:00",
    "emarsysWebExtend": false,
    "emarsysWebExtendMerchantId": "1544C661C98B7796",
    "cmpConsilius3dViewer": {
      "language": "sv"
    }
  },
  "abTests": {},
  "showTelephoneContactOnFailedCheckoutThreshold": 0
}
export default config